import React from "react";
import { getContrastingTextColor, getVenueColor } from "src/util/venueColors";

const venueBadge = (item) => {
  if (!item.venueName) return null;
  
  const backgroundColor = getVenueColor(item.venueId);
  const textColor = getContrastingTextColor(backgroundColor);
  
  return (
    <span 
      className="venue-badge"
      style={{
        backgroundColor,
        color: textColor
      }}
    >
      {item.venueName}
    </span>
  );
};

export default venueBadge;